import Input, { InputProps } from "@/components/atoms/Input";
import clsx from "clsx";
import { Search } from "lucide-react";

type Props = InputProps & {
  onSearch: (value: string) => void;
  placeholder?: string;
};

const SearchBox = ({ onSearch, className, placeholder, ...props }: Props) => {
  const classes = clsx(
    "bg-background text-dark dark:text-white border-border h-9 pr-7 focus-visible:border-slate-400 focus-visible:ring-0 focus-visible:outline-none focus-visible:ring-offset-0",
    className
  );

  return (
    <div className="flex items-center w-full max-w-xs sm:max-w-sm lg:max-w-md relative">
      <Input
        className={classes}
        onChange={(e) => onSearch(e.target.value)}
        placeholder= {placeholder || "Search..."}
        {...props}
      />
      <Search size={16} className="absolute right-3" />
    </div>
  );
};

export default SearchBox;
